import { useMemo } from 'react';
import { appContextToTrackingDataPixel } from '@core/tracking';
import { useStore } from '@core/widgets/store';
import { appContextSelector, paramsSelector, } from '@core/widgets/store/selectors';
/**
 * Common helper hook used by sibling hooks.
 */
export const useTracking = () => {
    const appContext = useStore(appContextSelector);
    const params = useStore(paramsSelector);
    const pixelTrackingData = useMemo(() => appContextToTrackingDataPixel({ appContext }), [appContext]);
    return {
        params,
        pixelTrackingData,
    };
};
